import { Box, Typography, TextField, Button, Divider } from "@mui/material";

export default function DiscussionsTab() {
  const discussions = [
    { user: "Amit", message: "I didn’t understand topic 2.4", date: "2 days ago" },
    { user: "Rahul", message: "Great explanation!", date: "1 day ago" },
  ];

  return (
    <Box>
      <Typography variant="h6" mb={2}>Discussions</Typography>

      {discussions.map((d, idx) => (
        <Box key={idx} mb={2}>
          <Typography fontWeight={600}>{d.user} <span style={{ fontWeight: 400, color: "#888" }}>• {d.date}</span></Typography>
          <Typography fontSize={14} color="text.secondary">{d.message}</Typography>
          <Divider sx={{ my: 1 }} />
        </Box>
      ))}

      <TextField fullWidth label="Ask a question..." multiline rows={3} sx={{ mb: 2 }} />
      <Button variant="contained">Post</Button>
    </Box>
  );
}
